import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import('./world-ranking-statistics/app.module').then(m => m.AppModule)
  },
  {
    path: "",
    loadChildren: () => import('./calendar/app.module').then(m => m.AppModule)
  },
  {
    path: "events/indoor",
    loadChildren: () => import('./indoor-module/app.module').then(m => m.AppModule)
  },


  {
    path: "world-cup-ranking",
    redirectTo: 'ranking/world-cup-ranking',
    pathMatch: 'full'
  },
  {
    path: "world-ranking",
    redirectTo: 'ranking/world-ranking',
    pathMatch: 'full'
  },
  {
    path: "prize-precision",
    redirectTo: 'ranking/prize-precision',
    pathMatch: 'full'
  },
  {
    path: "classement-mondial",
    redirectTo: 'ranking/classement-mondial',
    pathMatch: 'full'
  },
  {
    path: "classements-coupe-du-monde",
    redirectTo: 'ranking/classements-coupe-du-monde',
    pathMatch: 'full'
  },
  {
    path: "prix-precision",
    redirectTo: 'ranking/prix-precision',
    pathMatch: 'full'
  },
  {
    path: "events/calendar",
    loadChildren: () => import('./calendar/app.module').then(m => m.AppModule)
  },
  {
    path: "calendar",
    loadChildren: () => import('./calendar/app.module').then(m => m.AppModule)
  },
  {
    path: "events/results",
    loadChildren: () => import('./results/app.module').then(m => m.AppModule)
  },
  {
    path: "rulebook",
    loadChildren: () => import('./rulebook/app.module').then(m => m.AppModule)
  },
  {
    path: 'members',
    loadChildren: () => import('./members/members.module').then(m => m.MembersModule)
  },
  {
    path: 'membres',
    loadChildren: () => import('./members/members.module').then(m => m.MembersModule)
  },
  { path: 'member', loadChildren: './members/details-page/details-page.module#DetailsPageModule' },


  { path: 'athlete/photos/:id', redirectTo: 'profile/photos/:id', pathMatch: 'full' },
  { path: 'athlete/:id', redirectTo: 'profile/:id', pathMatch: 'full' },
  { path: 'athlete/:id/:name', redirectTo: 'profile/:id/:name', pathMatch: 'full' },
  { path: 'athlete/:id/:name/results', redirectTo: 'profile/:id/:name/results', pathMatch: 'full' },
  { path: 'athlete/:id/:name/biography', redirectTo: 'profile/:id/:name/biography', pathMatch: 'full' },
  { path: 'athlete/:id/:name/statistics', redirectTo: 'profile/:id/:name/statistics', pathMatch: 'full' },
  { path: 'athlete/:id/:name/photos', redirectTo: 'profile/:id/:name/photos', pathMatch: 'full' },
  { path: 'athlete/:id/:name/news', redirectTo: 'profile/:id/:name/news', pathMatch: 'full' },
  { path: 'athlete/:id/:name/matches', redirectTo: 'profile/:id/:name/matches', pathMatch: 'full' },
  { path: 'athletes', loadChildren: () => import('./athletes/athletes.module').then(m => m.AthletesModule) },

  { path: 'officials', loadChildren: './officials/officials.module#OfficialsModule' },
  { path: 'coaches', loadChildren: './coaches/coaches.module#CoachesModule' },
  { path: 'profile', loadChildren: './athlete/athlete.module#AthleteModule' },
  { path: 'profile/photos/:id', loadChildren: './athlete/athlete.module#AthleteModule' },
  { path: 'profile/:id', loadChildren: './athlete/athlete.module#AthleteModule' },
  { path: 'profile/:id/:name', loadChildren: './athlete/athlete.module#AthleteModule' },
  { path: 'competition/:id/:name', loadChildren: () => import('./competitions/competitions.module').then(m => m.CompetitionsModule) },
  { path: 'competition/:id', loadChildren: () => import('./competitions/competitions.module').then(m => m.CompetitionsModule) },
  { path: 'entry/:id', redirectTo: 'athlete/:id', pathMatch: 'full' },
  { path: 'rankings', loadChildren: () => import('./ranking-tabs/ranking-tabs.module').then(m => m.RankingTabsModule)},
  { path: 'rankings', redirectTo: 'rankings/world-ranking' },
  { path: 'ranking', redirectTo: 'rankings/world-ranking' },
  { path: 'ranking/world-ranking', redirectTo: 'rankings/world-ranking' },
  { path: 'ranking/world-cup-ranking', redirectTo: 'rankings/world-cup-ranking' },
  { path: 'ranking/prize-precision', redirectTo: 'rankings/prize-precision' },
  { path: 'rankings/longines-prize-precision', redirectTo: 'rankings/prize-precision' },
  { path: 'ranking/world-ranking', redirectTo: 'rankings/world-ranking' },
  { path: 'ranking/world-cup-ranking', redirectTo: 'rankings/world-cup-ranking' },
  { path: 'ranking/prix-precision', redirectTo: 'ranking/prix-precision' },
  { path: 'ranking/prix-longines-precision', redirectTo: 'rankings/prix-precision' },
  { path: 'ranking/classement-mondial', redirectTo: 'rankings/classement-mondial' },
  { path: 'ranking/classements-coupe-du-monde', redirectTo: 'rankings/classements-coupe-du-monde' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration:'disabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
